<template>
    <div>
        <SoliForm
            title="Reassign Room"
            imgSrc="https://kylelamoreaux.github.io/dublin-room.png"
            text="Save"
            icon="save"
            ref="form"
            @reset="reset"
            @submit="submit"
            @success="$emit('success')"
        >
            <template #body>
                <div class="flex align-center">
                    <div class="soli-grey flex-1 pt-4 px-3">
                        {{ `Move ${moveTeacher} to ${roomName}?` }}
                    </div>
                    <v-progress-circular
                        indeterminate
                        color="primary"
                        class="mx-3"
                        v-if="loading"
                    >
                    </v-progress-circular>
                </div>
                <v-simple-table
                    class="soli-grey v-sheet--outlined my-4"
                    v-if="lessons.length"
                >
                    <thead>
                        <tr>
                            <th class="soli-caption soli-grey">
                                Affected students:
                            </th>
                            <th class="soli-caption soli-grey">Start:</th>
                        </tr>
                    </thead>
                    <tbody v-show="!loading">
                        <tr v-for="lesson in lessons" :key="lesson.id">
                            <td>
                                {{ lesson.student?.name }}
                            </td>
                            <td>
                                {{
                                    globalMomentFullDateAtTime(lesson.starts_at)
                                }}
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </template>
        </SoliForm>
        <SoliForm
            v-if="showSelectAssign"
            title="Which assignment?"
            ref="selectAssign"
            hideBtn
            persistent
            permanent
            @reset="showSelectAssign = false"
            ><template #body>
                <v-list>
                    <v-list-item
                        v-for="assignment in assignments"
                        :key="assignment.id"
                    >
                        <SoliBtn
                            block
                            @click="
                                [
                                    (selectedAssignment = assignment),
                                    getAffectedLessons(),
                                    $refs.selectAssign.reset(),
                                ]
                            "
                            :text="globalMomentTime(assignment.starts_at)"
                            color="soli-grey"
                            outlined
                            class="mb-3"
                        >
                        </SoliBtn>
                    </v-list-item>
                </v-list>
            </template>
        </SoliForm>
        <SoliChoice
            v-if="futureConflict"
            title="Uh oh"
            :subtitle="`${
                futureConflict.roomConflict
                    ? futureConflict.roomConflict
                    : assignments[0].teacher.name
            }
                       is already assigned at this time, starting ${globalMomentDate(
                           new Date(
                               futureConflict.date || futureConflict.starts_at
                           )
                       )}. Would you like to move ${
                assignments[0].teacher.first_name
            }'s assignments anyways?`"
            button1="Ok"
            button2="Nevermind"
            @option1="
                (futureConflict = null),
                    (form.noConflict = true),
                    ($refs.form.loading = true),
                    submit()
            "
            @option2="[(form.noConflict = false), ($refs.form.loading = false)]"
            @reset="futureConflict = null"
        >
        </SoliChoice>
        <SoliChoice
            v-if="showMoveInStudioWarning"
            permanent
            title="Are you sure"
            :subtitle="`You are moving this assignment in-studio. ${selectedAssignment.teacher.first_name}'s lessons will remain online for students. ${selectedAssignment.teacher.first_name}'s online room will no longer be available.`"
            button1="I understand"
            button2="Nevermind"
            @option1="[closeModal(() => (showMoveInStudioWarning = false))]"
            @reset="
                [
                    closeModal(() => (showMoveInStudioWarning = false)),
                    (saveChanges = false),
                ]
            "
        />
    </div>
</template>

<script>
import globalMoment from "../../Mixins/GlobalMoment.js";

export default {
    name: "ReassignRoom",
    props: ["assignments", "reassignEvent"],
    mixins: [globalMoment],
    data() {
        return {
            form: {
                teachers: null,
                noConflict: false,
            },
            futureConflict: null,
            lessons: [],
            loading: null,
            showSelectAssign: false,
            selectedAssignment: null,
            showMoveInStudioWarning: false,
        };
    },
    methods: {
        submit() {
            let update = {
                //affectedLessons: this.lessons, //? this.lessons.map((e) => e.id) : null,
                //affectedAssignments: this.assignments.map((e) => e.id),
                id: this.selectedAssignment.id,
                room_id: this.moveRoom,
                starts_at: this.selectedAssignment.starts_at, //moment(this.selectedAssignment.starts_at).format(),
                ends_at: this.selectedAssignment.ends_at, //moment(this.selectedAssignment.ends_at).format(),
                recurrence_end: this.selectedAssignment.recurrence?.ends_at,
                recurrence_id: this.selectedAssignment.recurrence_id,
                futureEvents: true,
                noConflict: this.form.noConflict,
                cancelled: false,
                user_id: this.selectedAssignment.teacher.id,
                reassignRoom: true,
                subTeacher: null,
            };

            this.$inertia.put(
                this.route("assignment.update", this.selectedAssignment.id),
                update,
                {
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: () => {
                        //this.$refs.dialog.reset();
                        this.$refs.form.dialog = false;
                        this.$emit("success");
                    },
                    onError: (errors) => {
                        console.log(
                            "Form returned errors: " + JSON.stringify(errors)
                        );
                        this.$refs.form.loading = false;
                        this.futureConflict = errors;
                    },
                }
            );
        },
        reset() {
            this.reassignEvent.revert();
            this.$emit("reset");
        },
        getAffectedLessons() {
            if (this.loading == null) this.loading = true;
            return axios
                .get("/api/assignments/unique-lessons", {
                    params: {
                        assignment_id: [this.selectedAssignment.id],
                    },
                })
                .then((resp) => {
                    this.lessons = resp.data;
                    this.loading = false;
                });
        },
    },
    computed: {
        roomName() {
            return this.reassignEvent
                ? this.reassignEvent.newResource.title
                : null;
        },
        moveRoom() {
            return this.reassignEvent
                ? this.reassignEvent.newResource.id
                : null;
        },
        moveTeacher() {
            return this.reassignEvent ? this.reassignEvent.event.title : null;
        },
        studentName() {
            if (this.reassignEvent && this.lessons) {
                let arr = this.lessons.map((lesson) => lesson.student?.name);
                arr = arr.filter(
                    (event, index, self) =>
                        index === self.findIndex((e) => e === event) // TODO add recurring lesson indicator?
                );
                return arr;
            }
        },
    },
    mounted() {
        if (this.assignments.length > 1) {
            this.showSelectAssign = true;
            return;
        } else {
            this.selectedAssignment = this.assignments[0];
            this.getAffectedLessons();
        }
        /*if (this.selectedAssignment.availability.online_only) {
            this.reset();
        }*/
        if (!this.selectedAssignment.room.user_id) return;

        let newRoomOnlineTeacher =
            this.reassignEvent.newResource.extendedProps.user_id;
        if (!newRoomOnlineTeacher && this.selectedAssignment.room.user_id) {
            this.showMoveInStudioWarning = true;
            return;
        }
        if (newRoomOnlineTeacher !== this.selectedAssignment.teacher.id) {
            this.reset();
        }
    },
};
</script>
